import { LabelModel, LabelResponse } from 'types';
import genericNormalizer from './generic';

export const normalizeLabel = genericNormalizer<LabelResponse, LabelModel>(
  ({ from }) => ({
    color: from('color'),
    id: from('id'),
    idBoard: from('idBoard'),
    name: from('name'),
  }),
);



// WEBPACK FOOTER //
// ./app/gamma/src/api/normalizers/label.ts